import { useEffect } from 'react'
import Pagination from 'components/pagination/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { setReportName } from 'features/report/reportAddSlice'
import ReportAddHeader from 'features/report/ReportAddHeader'
import TextInput from 'components/form/TextInput'
import useValidator from 'utils/hooks/useValidator'
import { isNullOrUndefined, isNullOrUndefinedOrEmpty } from 'utils'
import ErrorText from 'components/form/ErrorText'
import { useHistory, useParams } from 'react-router-dom'
import {
  AD_ACCOUNT,
  AD_GROUP,
  CAMPAIGN,
  CREATIVE,
  KEYWORD,
} from 'features/report/common/DomainText'
import ReportAdGroupTable from 'features/report/table/ReportAdGroupTable'
import ReportAdAccountTable from 'features/report/table/ReportAdAccountTable'
import ReportCampaignTable from 'features/report/table/ReportCampaignTable'
import ReportKeywordTable from 'features/report/table/ReportKeywordTable'
import ReportCreativeTable from 'features/report/table/ReportCreativeTable'
import { trim } from 'lodash'
import useReportViewMode from 'features/report/hooks/useReportViewMode'
import useTableUpdater from 'features/report/hooks/useTableUpdater'
import PageHeader from 'components/PageHeader'
import { useAlert } from 'features/dialog/Alert'
import { getErrorMessage } from 'features/ErrorMessages'

const ReportAdd = () => {
  const dispatch = useDispatch()
  const {
    page,
    total,
    size,
    apiError,
    formValues: { domain, name, campaignId, adGroupId },
  } = useSelector(state => state.report.reportAdd)

  const { accountId } = useParams()
  const history = useHistory()
  const mode = useReportViewMode()
  const [renderableDomain, setPage] = useTableUpdater()
  const [ErrorAlert, showErrorAlert, hideErrorAlert] = useAlert()
  const { errors, validate, addError, clearError } = useValidator(() => ({
    nameMissing:
      isNullOrUndefinedOrEmpty(trim(name)) && '맞춤보고서 이름을 입력하세요.',
    campaignMissing:
      domain === AD_GROUP &&
      isNullOrUndefinedOrEmpty(campaignId) &&
      '캠페인을 선택하세요.',
    groupMissing:
      (domain === KEYWORD || domain === CREATIVE) &&
      isNullOrUndefined(adGroupId) &&
      '광고그룹을 선택하세요.',
  }))

  useEffect(() => {
    clearError('nameDuplicated')
    if (isNullOrUndefined(apiError)) return
    if (apiError) addError({ nameDuplicated: getErrorMessage(apiError) })
  }, [dispatch, apiError, clearError, addError])

  const onCancel = () => history.push(`/${accountId}/report`)
  const onSave = async () => {
    try {
      await validate()
    } catch (e) {
      if (e.campaignMissing || e.groupMissing || e.nameMissing) {
        showErrorAlert()
      }
      return
    }
    const { error } = await dispatch(mode.saveFunc(mode.reportIdPathVariable))
    if (!error) history.push(`/${accountId}/report`)
  }

  return (
    <>
      <ErrorAlert title="" confirmText="확인" onClose={() => hideErrorAlert()}>
        {errors.campaignMissing || errors.groupMissing || errors.nameMissing}
      </ErrorAlert>

      <div className="report_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle={mode.pageTitle} />
        </div>
        <div className="set_table">
          <ReportAddHeader />

          {renderableDomain === AD_ACCOUNT && <ReportAdAccountTable />}
          {renderableDomain === AD_GROUP && <ReportAdGroupTable />}
          {renderableDomain === CAMPAIGN && <ReportCampaignTable />}
          {renderableDomain === KEYWORD && <ReportKeywordTable />}
          {renderableDomain === CREATIVE && <ReportCreativeTable />}

          <div className="set_foot">
            {total > 0 && (
              <div className="paging_wrap">
                <div className="inner_paging">
                  <Pagination
                    current={page}
                    total={total}
                    size={size}
                    onChange={newPage => setPage(newPage)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">맞춤보고서명</strong>
          </div>
          <table className="tbl_g3">
            <caption className="hide_caption">맞춤보고서명 입력 표</caption>
            <colgroup>
              <col />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <div className="inner_tbl">이름 입력</div>
                </th>
                <td>
                  <div className="inner_tbl">
                    <TextInput
                      maxLength={50}
                      value={name}
                      placeholder="맞춤보고서 이름을 입력하세요."
                      onValueChange={v => dispatch(setReportName(v))}
                    />
                    <ErrorText error={errors.nameMissing} />
                    <ErrorText error={errors.nameDuplicated} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="page_btn">
          <div className="inner_btn">
            <button type="button" className="btn_gb" onClick={onCancel}>
              <span className="inner_g">취소</span>
            </button>
            <button type="button" className="btn_gb gb_bl" onClick={onSave}>
              <span className="inner_g">{mode.text}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ReportAdd
